const ZohoContactForm = () => {
  return (
    <iframe
      src="/zoho-form.html"
      title="Contact Form"
      style={{
        width: '100%',
        minHeight: '740px',
        border: 'none',
        display: 'block',
      }}
    />
  );
};

export default ZohoContactForm;
